import { h, Component, Prop } from '@stencil/core';
import { modalController } from "@ionic/core";

@Component({
  tag: 'tip-legend-button'
})
export class LegendButton {
  @Prop() options: any[];
  @Prop() revision: number = 1;

  private async openPopover(ev: UIEvent) {
    const options = {
      component: document.createElement('tip-legend'),
      componentProps: {
        options: this.options,
        revision: this.revision
      },
      event: ev
    };
    const modal = await modalController.create(options);
    await modal.present();
    return modal;
  }

  render() {
    return (
      <ion-button ion-button
        onClick={(e: UIEvent) => this.openPopover(e)}>
        Legend
      </ion-button>
    );
  }
}
